import { autoinject, bindable } from 'aurelia-framework';
import { ScopeTypeService, ScopeType } from './scope-type-service';

@autoinject
export class ScopeTypeSelect {
	@bindable selectedScopeType: ScopeType;

	scopeTypes: ScopeType[];

	constructor(private typeService: ScopeTypeService) {}

	async attached() {
		this.scopeTypes = await this.typeService.getScopeTypes();
	}
}
